var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.875 3.75195C3.97989 3.75195 3.12145 4.10753 2.48851 4.74047C1.85558 5.3734 1.5 6.23185 1.5 7.12695V16.877C1.5 17.7721 1.85558 18.6305 2.48851 19.2634C3.12145 19.8964 3.97989 20.252 4.875 20.252H19.125C20.0201 20.252 20.8785 19.8964 21.5115 19.2634C22.1444 18.6305 22.5 17.7721 22.5 16.877V7.12695C22.5 6.23185 22.1444 5.3734 21.5115 4.74047C20.8785 4.10753 20.0201 3.75195 19.125 3.75195H4.875ZM21 7.8042L12 12.65L3 7.8042V7.12695C3 6.62967 3.19754 6.15276 3.54917 5.80113C3.90081 5.4495 4.37772 5.25195 4.875 5.25195H19.125C19.6223 5.25195 20.0992 5.4495 20.4508 5.80113C20.8025 6.15276 21 6.62967 21 7.12695V7.8042ZM3 9.50745L11.6445 14.1627C11.7538 14.2215 11.8759 14.2523 12 14.2523C12.1241 14.2523 12.2462 14.2215 12.3555 14.1627L21 9.50745V16.877C21 17.3742 20.8025 17.8511 20.4508 18.2028C20.0992 18.5544 19.6223 18.752 19.125 18.752H4.875C4.37772 18.752 3.90081 18.5544 3.54917 18.2028C3.19754 17.8511 3 17.3742 3 16.877V9.50745Z",
    fill: "#36D66B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.d0df9db6342697257e0f1f94411f1766.svg";
export { ForwardRef as ReactComponent };